<button type="button"
  class="btn btn-complex-datepicker btn-lg w-100 text-start mb-1 fs-12 rounded"
  (click)="onOpenCloseWidget()">
  <span [innerHTML]=getButtonLabel()></span>
  <span
    class="fs-14"
    (mouseover)="onCalendarIconMouseOver()"
    (mouseout)="onCalendarIconMouseOut()">
    <ng-container *ngIf="isCloseIconDisplayed; else noCloseIcon">
      <a class="float-lg-end" (click)="clearWidget()">
        <i nz-icon nzType="close-circle" nzTheme="fill"></i>
      </a>
    </ng-container>
    <ng-template #noCloseIcon>
      <span class="float-lg-end">
        <i nz-icon nzType="calendar" nzTheme="outline"></i>
      </span>
    </ng-template>
  </span>
</button>

<ng-container *ngIf="isWidgetDisplayed">
  <div class="complex-datepicker-parent-container bg-light p-3 rounded">
    <!-- Shortcuts -->
    <div class="form-group">
      <div class="mb-2">
        <button
          type="button"
          [ngClass]="{'btn w-100 text-start rounded p-3 mt-2': true, 'bg-light-x': isCollapsed.shortcut}"
          (click)="isCollapsed.shortcut = !isCollapsed.shortcut"
          [attr.aria-expanded]="!isCollapsed.shortcut"
          aria-controls="shortcuts-container">
          <span class="mb-0 fs-12 font-weight-bold">
            <span class="me-1"><i class="fa fa-bars"></i></span>
            Shortcuts
            <span class="float-lg-end">
              <ng-container *ngIf="isCollapsed.shortcut; else downCaret">
                <i class="fa fa-chevron-up"></i>
              </ng-container>
            </span>
          </span>
        </button>
      </div>

      <div id="shortcuts-container" [ngbCollapse]="isCollapsed.shortcut">
        <ul class="list-group">
          <li
            *ngFor="let shortcut of shortcuts"
            [ngClass]="{
            'list-group-item list-group-item-action p-2 px-3 pe-3': true,
            'active': isShortcutSelected(shortcut),
            'disabled': disabled
            }">
            <a (click)="onSelectShortcut(shortcut)" class="d-block w-100">
              {{ shortcut.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- Shortcuts -->

    <!-- Date Range -->
    <div class="form-group">
      <div class="mb-2">
        <button
          type="button"
          [ngClass]="{'btn w-100 text-start rounded p-3 mt-2': true, 'bg-light-x': isCollapsed.datetime}"
          (click)="isCollapsed.datetime = !isCollapsed.datetime"
          [attr.aria-expanded]="!isCollapsed.datetime"
          aria-controls="datetime-container">
          <span class="mb-0 fs-12 font-weight-bold">
            <span class="me-1"><i class="fa fa-bars"></i></span>
            Date & Time
            <span class="float-lg-end">
              <ng-container *ngIf="isCollapsed.datetime; else downCaret">
                <i class="fa fa-chevron-up"></i>
              </ng-container>
            </span>
          </span>
        </button>
      </div>

      <div id="datetime-container mb-3" [ngbCollapse]="isCollapsed.datetime">
        <form [formGroup]="datetime_form" (ngSubmit)="onSubmitDateTimeForm()">
          <div class="form-group">
            <nz-date-picker
              [formControl]="datetime_start"
              [nzShowTime]="{nzDefaultOpenValue: getDefaultTime()}"
              nzFormat="dd-MM-yyyy HH:mm:ss"></nz-date-picker>
            <span class="d-block w-100 text-center p-1">- TO -</span>
            <nz-date-picker
              [formControl]="datetime_end"
              [nzShowTime]="{nzDefaultOpenValue: getDefaultTime()}"
              nzFormat="dd-MM-yyyy HH:mm:ss"></nz-date-picker>

            <div *ngIf="datetime_form.errors?.invalidDateInterval" class="invalid-feedback force-show">
              Start Time must be no greater than End Time.
            </div>
          </div>

          <div *ngIf="datetime_form.touched && datetime_form.errors">
            <div *ngIf="datetime_form.errors?.invalidCount" class="mb-1 mb-3 invalid-feedback force-show">
              Please select at least one date.
            </div>
          </div>

          <div class="form-group">
            <button type="submit"
              class="btn btn-info btn-filter float-lg-end"
              [disabled]="datetime_form.invalid">Apply</button>
          </div>
        </form>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- Date Range -->

    <!-- Relative Time -->
    <div class="form-group mb-0">
      <div class="mb-2">
        <button
          type="button"
          [ngClass]="{'btn w-100 text-start rounded p-3 mt-2': true}"
          (click)="isCollapsed.relative = !isCollapsed.relative"
          [attr.aria-expanded]="!isCollapsed.relative"
          aria-controls="relative-time-container">
          <span class="mb-0 fs-12 font-weight-bold">
            <span class="me-1"><i class="fa fa-bars"></i></span>
            Relative Time
            <span class="float-lg-end">
              <ng-container *ngIf="isCollapsed.relative; else downCaret">
                <i class="fa fa-chevron-up"></i>
              </ng-container>
            </span>
          </span>
        </button>
      </div>

      <div id="relative-time-container" [ngbCollapse]="isCollapsed.relative">
        <form [formGroup]="relative_time_form" (ngSubmit)="onSubmitRelativeTime()">
          <div class="form-group">
            <div class="row">
              <div class="col col-4">
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  [formControl]="relative_time_value"
                  placeholder="4"
                  numberWheel
                >
              </div>
              <div class="col col-8">
                <select class="form-control" [formControl]="relative_time_unit">
                  <option *ngFor="let unit of relative_time_units" [value]="unit"> {{ unit }} </option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col col-12">
                <select class="form-control" [formControl]="relative_time_moment">
                  <option *ngFor="let moment of relative_time_moments" [value]="moment"> {{ moment }} </option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <nz-date-picker
              [formControl]="relative_time_ref_date"
              [nzShowTime]="{nzDefaultOpenValue: getDefaultTime()}"
              nzFormat="dd-MM-yyyy HH:mm:ss"></nz-date-picker>
          </div>

          <div class="form-group mb-0">
            <div class="row">
              <div class="col col-12">
                <label for="ref-now">
                  <input type="checkbox"
                   id="ref-now"
                   [formControl]="relative_time_ref_now"
                   (change)="onChangeCheckboxNow($event)">
                  <span class="ms-1">NOW</span>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <button
              type="submit"
              class="btn btn-info btn-filter float-lg-end"
              [disabled]="relative_time_form.invalid">Apply</button>
          </div>
        </form>
        <div class="clearfix"></div>
      </div>
    </div>

    <!-- Snapshot Now -->
    <ng-container *ngIf="display.snapshot">
      <div class="form-group">
        <div class="mb-2">
          <button
            type="button"
            (click)="onSnapshotNow()"
            [ngClass]="{'btn w-100 text-center rounded p-3 mt-2': true, 'active': isSnapshotSelected()}">
            <span class="mb-0 fs-12 font-weight-bold">Snapshot NOW</span>
          </button>
        </div>
      </div>
    </ng-container>
    <!-- Snapshot Now -->

    <ng-template #downCaret>
      <i class="fa fa-chevron-down"></i>
    </ng-template>
  </div>
</ng-container>
